import { render, staticRenderFns } from "./i18n-flags.vue?vue&type=template&id=12d713ae&"
import script from "./i18n-flags.vue?vue&type=script&lang=js&"
export * from "./i18n-flags.vue?vue&type=script&lang=js&"
import style0 from "./i18n-flags.vue?vue&type=style&index=0&lang=css&"
import style1 from "./i18n-flags.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports